export default "__VITE_ASSET__BYRd3gma__"